
import { all, fork } from 'redux-saga/effects';

import * as authenticationSaga from '../auth/AuthenticationSaga';

export default function* rootSaga() {
    yield all([
        ...Object.values(authenticationSaga),
    ].map(fork))
}

